/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { cpfMask, landlineTelephoneMask, phoneMask, proposalMask } from '../../../utils/masks';
import TextInput from '../../atoms/TextInput';

function Step1({ handleChange, handleBlur, values, touched, errors }) {
  return (
    <>
      <h4>Dados do responsável pela loja</h4>
      <TextInput
        placeholder="Nome do responsável"
        name="responsibleName"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.responsibleName}
        completed={touched.responsibleName && !errors.responsibleName}
        error={touched.responsibleName && errors.responsibleName}
      />

      <TextInput
        placeholder="Telefone"
        name="responsiblePhone"
        onBlur={handleBlur}
        completed={touched.responsiblePhone && !errors.responsiblePhone}
        error={touched.responsiblePhone && errors.responsiblePhone}
        onChange={(ev) => {
          const cleanValue = ev.target.value.replace(/[^0-9]/gi, '');

          if (cleanValue.length >= 11) {
            ev.target.value = phoneMask(cleanValue.slice(0, 11));
          } else {
            ev.target.value = landlineTelephoneMask(cleanValue.slice(0, 11));
          }

          handleChange(ev);
        }}
        value={values.responsiblePhone}
      />

      <TextInput
        placeholder="Outro telefone"
        name="responsiblePhone2"
        onBlur={handleBlur}
        completed={touched.responsiblePhone2 && !errors.responsiblePhone2}
        error={touched.responsiblePhone2 && errors.responsiblePhone2}
        onChange={(ev) => {
          const cleanValue = ev.target.value.replace(/[^0-9]/gi, '');

          if (cleanValue.length >= 11) {
            ev.target.value = phoneMask(cleanValue.slice(0, 11));
          } else {
            ev.target.value = landlineTelephoneMask(cleanValue.slice(0, 11));
          }

          handleChange(ev);
        }}
        value={values.responsiblePhone2}
      />

      <TextInput
        placeholder="Email"
        name="responsibleEmail"
        onChange={handleChange}
        value={values.responsibleEmail}
        onBlur={handleBlur}
        completed={touched.responsibleEmail && !errors.responsibleEmail}
        error={touched.responsibleEmail && errors.responsibleEmail}
      />

      <h4>Dados do cliente</h4>
      <TextInput
        placeholder="CPF"
        name="clientCPF"
        onChange={(ev) => {
          ev.target.value = cpfMask(ev.target.value);

          handleChange(ev);
        }}
        value={values.clientCPF}
        onBlur={handleBlur}
        completed={touched.clientCPF && !errors.clientCPF}
        error={touched.clientCPF && errors.clientCPF}
      />
      <TextInput
        placeholder="Número da proposta Santander"
        name="proposalNumber"
        maxLength={9}
        minLength={6}
        onChange={(ev) => {
          ev.target.value = proposalMask(ev.target.value);
          handleChange(ev);
        }}
        value={values.proposalNumber}
        onBlur={handleBlur}
        completed={touched.proposalNumber && !errors.proposalNumber}
        error={touched.proposalNumber && errors.proposalNumber}
      />

      <div className="disclaimer-form">
        <img src="assets/rastreadores/disc.svg" alt="" />
        <p>Confirme se os dados foram preenchidos corretamente</p>
      </div>
    </>
  );
}

export default Step1;
